import { ShapeOutlineIcon } from './ShapeOutlineIcon';

/**
 * author: Google
 * id FC3A1E7D-F8CD-443E-A685-9C7F0FA9FC10
 * name shape-outline
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shape-outline.svg
 * tags
 * - Shape 
 */
export const ThemeOutlineIcon = ShapeOutlineIcon;
export default ThemeOutlineIcon